import * as React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@material-ui/core';

export class SimpleSelect extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.state = { value: props.defaultValue };

        this.handleChange = this.handleChange.bind(this);
    }

    private handleChange(event: React.ChangeEvent<HTMLSelectElement>) {
        var newValue = event.target.value;
        this.setState({value: newValue});
        if (this.props.onChange != null) {
            this.props.onChange(newValue);
        }
    }

    public render() {
        var value = this.state.value;
        if (value == null) {
            value = "";
        }
        return (
            <FormControl style={{width: '100%', marginBottom: '24px', textAlign: 'left'}} error={this.props.error != null} disabled={this.props.disabled != null}>
                {this.props.label && (
                    <InputLabel >{this.props.label}</InputLabel>
                )}
                <Select
                    style={{width: "100%"}} 
                    value={value}
                    onChange={this.handleChange}
                >
                    {this.mapChildren()}
                </Select>
                {(this.props.error || this.props.infoText) && (
                    <FormHelperText>{this.props.error != null ? this.props.error : this.props.infoText}</FormHelperText>
                )}
            </FormControl>
        );
    }

    private mapChildren() {
        if (Array.isArray(this.props.children)) {
            return this.props.children.map((item: React.ReactElement<any, any>) => {
                if (item.type.name === "SelectItem") {
                    return (<MenuItem key={"mi-" + item.props.value} value={item.props.value}>{item.props.title}</MenuItem>);
                }
            })
        } else {
            var c = this.props.children as React.ReactElement<any, any>;
            return (
                <MenuItem key={"mi-" + c.props.value} value={c.props.value}>{c.props.title}</MenuItem>
            )
        }
    }

}

export class SelectItem extends React.Component<{value: string, title: string}, {}> {

    public render() {
        return (
            <MenuItem value={this.props.value}>{this.props.title}</MenuItem>
        );
    }

}

export class Props {

    public defaultValue?: string;
    public label?: string;
    public error?: string;
    public infoText?: string;
    public disabled?: boolean;
    public onChange?: {(newValue: string): void};
    public children?: React.ReactNode;

}

class State {

    public value: string;

}